import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import './styles/tailwind.css'
import App from './app/App.tsx'
import { AuthProvider } from './app/context/AuthContext'
import { queryClient } from './app/lib/queryClient'
import { Toaster } from './app/components/ui/toaster'

Sentry.init({
  dsn: 'https://552f70c639b6afa40e8720b8fca244bd@o4511572772323328.ingest.us.sentry.io/4511572778352640',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
})

posthog.init('phc_AiX2SiFewnyycHYfrZVKoYgHWqHMYAyzEyRpXpTj7Dj4', {
  api_host: 'https://us.i.posthog.com',
  capture_pageview: false,   // fired manually in App.tsx on each route change
  capture_pageleave: true,
  // Only create PostHog person profiles for identified (signed-in) users.
  person_profiles: 'identified_only',
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
            <Toaster />
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </PostHogProvider>
  </StrictMode>,
)
